var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconShare = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.419v2.58h6a1 1 0 0 1 1 1.001v12a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h6V6.416l-1.13 1.129a.993.993 0 0 1-1.407-.007 1 1 0 0 1-.007-1.407l2.842-2.841a.988.988 0 0 1 .697-.29l.008.004c.254 0 .506.095.696.286L17.04 6.13a1 1 0 0 1-1.414 1.414L14.5 6.419zM12.5 11V9h-4a1 1 0 0 1 0 2h4zm2 0h5V9h-5v2zm-2 0h-5v10h12V11h-5v5.002a1 1 0 0 1-2 0V11zm7 0h-1a1 1 0 0 1 0-2h1v2z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconShare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-share.4add28ee.svg";
export { ForwardRef as ReactComponent };